var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row no-gutters" },
    [
      _c("div", { staticClass: "col-12 d-flex justify-content-center" }, [
        _c("p", { staticClass: "m-0" }, [
          _vm._v(
            "\n      " +
              _vm._s(_vm.$t("file.messages.noApplicationsLinked")) +
              "\n    "
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-12" }, [
        _c("div", { staticClass: "row justify-content-center" }, [
          _c("div", { staticClass: "col-auto mt-3 pb-md-4" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-primary btn-sm add-client",
                attrs: { disabled: _vm.isViewOnly },
                on: { click: _vm.createApplication },
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("application.actions.createApplication")) +
                    "\n        "
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-auto mt-3 pb-md-4" },
            [
              _c(
                "simple-button",
                {
                  attrs: {
                    type: "primary btn-sm",
                    loading: _vm.linkingLoading,
                    "loading-status": _vm.linkingStatus,
                  },
                  on: { click: _vm.showLinkAppModal },
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("application.actions.linkApplications")) +
                      "\n        "
                  ),
                ]
              ),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("link-applications-modal", {
        ref: "linkAppModal",
        attrs: { owner: _vm.profile.owner },
        on: { "link-application": _vm.linkApplication },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }